import React from "react";
import Card from "components/card";
import { Divider } from "antd";
import { MapPin, Clock } from "lucide-react";
import { formatDateRange } from "utils/index";
import LeaveApprovalForm from "views/console/attendances/leave-requests/components/LeaveApprovalForm";
import OvertimeApprovalForm from "views/console/attendances/overtime-requests/components/OvertimeApprovalForm";
import ApprovalButtons from "components/button/approvalbuttons";
import { MODULE_LEAVE_REQUESTS, MODULE_OVERTIME_REQUESTS } from "variables/constants";




const ApprovalCard = ({ recordData }) => {

  const {
    type,
    employee_name,
    employee_initials,
    date_from,
    date_to,
    ots_reason,
    lve_reason,
    country,
    lve_duration,
    date_file,
    lve_type_name,
    duration_string,
    ots_date_from
  } = recordData;
  
  return (

    <Card className="p-4 rounded-2xl border-2 border-orange-200 bg-white hover:border-orange-300 hover:shadow-md transition-all duration-200 space-y-3 overflow-hidden">        
      <div className="flex items-start justify-between gap-2 overflow-hidden">
        <div className="flex items-center gap-3 min-w-0 flex-1 overflow-hidden">
          <span className="flex w-10 h-10 items-center justify-center rounded-full border-2 bg-slate-100 font-semibold text-sm">
            {employee_initials}
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-[14px] font-semibold truncate">
              {employee_name}
            </p>
            <div className="flex items-center gap-1.5 mt-0.5 min-w-0 overflow-hidden">
              <MapPin className="w-3 h-3 text-slate-700 flex-shrink-0" />
              <span className="text-[11px] text-slate-700 truncate">
                {country}
              </span>
            </div>
          </div>
          <span
            className={`flex items-center text-xs border status-indicator ${type?.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {type}
          </span>
        </div>
      </div>

      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

      <div className="space-y-3">
        {type === "Leave" && (
          <>
            <div className="flex items-center justify-between gap-2">
              <span className="text-[11px] text-slate-700 font-semibold uppercase tracking-wide">
                Type
              </span>
              <span
                className={`flex items-center text-xs border status-indicator ${lve_type_name?.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {lve_type_name}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="p-2 rounded-xl bg-slate-50 border min-w-0">
                <span className="text-[10px] text-slate-700 font-semibold uppercase">
                  From
                </span>
                <p className="text-[12px] font-semibold truncate">
                  {formatDateRange(date_from)}
                </p>
              </div>
              <div className="p-2 rounded-xl bg-slate-50 border min-w-0">
                <span className="text-[10px] text-slate-700 font-semibold uppercase">
                  To
                </span>
                <p className="text-[12px] font-semibold truncate">
                  {formatDateRange(date_to)}
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-2 text-[12px] text-slate-700">
              <Clock className=" w-3.5 h-3.5 flex-shrink-0" />
              <span className="font-medium">
                {lve_duration} day{lve_duration > 1 ? "s" : ""}
              </span>
            </div>
          </> 
        )}
        {type === "Overtime" && (
          <>
            <div className="flex items-center justify-between p-3 rounded-xl bg-orange-50 border border-orange-200">
              <span className="text-[12px] font-semibold text-slate-700">
                Overtime Hours
              </span>
              <span className="text-[18px] font-bold text-orange-600">
                {duration_string}
              </span>
            </div>
            <div className="p-2 rounded-lg bg-slate-50 border min-w-0">
              <span className="text-[10px] text-slate-700 font-semibold uppercase">
                Date
              </span>
              <p className="text-[12px] font-semibold truncate">
                {formatDateRange(ots_date_from)}
              </p>
            </div>
          </>
        )}

        <div className="p-3 rounded-xl bg-slate-50 border">
          <span className="text-[11px] text-slate-700 font-semibold uppercase tracking-wide">
            Reason
          </span>
          <p className="text-[12px] mt-1 break-words">
            {type === "Leave"
              ? lve_reason
              : ots_reason
            }
          </p>
        </div>
        <div className="text-[11px] text-slate-700 tracking-normal font-medium gap-1">
          Requested on {formatDateRange(date_file)}
        </div>

       <div className="flex mt-4 gap-3">
          <ApprovalButtons
            record={recordData} 
            recordIdKey={type === "Overtime" ? "ots_id" : "lve_id"}
            employeeNameKey="employee_name"
            moduleId={type === "Overtime" ? MODULE_OVERTIME_REQUESTS : MODULE_LEAVE_REQUESTS}
            FormComponent={type === "Overtime" ? OvertimeApprovalForm : LeaveApprovalForm}
            modalPrefix={type === "Overtime" ? "edit_overtime_request" : "edit_leave_request"}
          />
        </div>
      </div>
      
    </Card>

  );
};

export default ApprovalCard;

